<div class="searchContainer">

  <div class="filtersContainer" [ngClass]="{'opened': showFilters, 'closed': !showFilters}">
    <p-panel header="{{ 'search_filters' | translate }}" [toggleable]="false" [collapsed]="false">
      <div *ngIf="mobileView" (click)="toggleFilters()" class="blueColorHover closeFilters"><i class="pi pi-times"></i></div>

      <div *ngIf="isLoadingFilters" class="loader"><p-progressSpinner></p-progressSpinner></div>

      <div *ngIf="!isLoadingFilters">

        <div class="filterLabel">{{ 'search_categories' | translate }}</div>
        <p-tree
          [value]="categoriesTree" class="searchCategoriesTree">
          <ng-template let-category  pTemplate="default">
            <div style="display: flex; align-items: center;">
              <mat-checkbox [checked]="category.checked" (change)="nodeSelect($event, category)" style="margin-right: 8px;"></mat-checkbox>
              <div [ngClass]="{'bolded': !category.parent_id, 'pointer': category.children}" (click)="nodeToggle(category)">{{ category.name }} <span *ngIf="category.parent_id">({{ category.count }})</span></div>
            </div>
          </ng-template>
        </p-tree>

        <div class="filterLabel">{{ 'search_arrangers' | translate }}</div>
        <div class="filtersSection arrangerSection" [ngClass]="{'arrangerSectionExpanded': arrangerFilterExpanded}">
          <div *ngFor="let arranger of arrangers" class="filter blueColor arrangerFilter">
            <mat-checkbox
              [(ngModel)]="arranger.checked"
              (change)="handleFiltersChange()"
              >{{ arranger.user_details.name + ' ' + arranger.user_details.surname }}</mat-checkbox>
          </div>
        </div>
        <div *ngIf="arrangers.length > 10 && !arrangerFilterExpanded" (click)="expandArrangerFilter()" class="expandArrangers blueColorHover">Pokaż wszystkich</div>

        <div class="filterLabel">{{ 'search_page_rating' | translate }}</div>
        <div class="ratingFilter blueColor">
          <div *ngFor="let rate of ratingFilterValues;  let i = index" class="rate">
            <mat-checkbox
              [checked]="ratingFilterSelected && ratingFilterSelected.rate == i"
              (change)="handleRatingFilterSelected($event, i)">{{rate.label}}</mat-checkbox>
          </div>
        </div>

        <div class="filterLabel">{{ 'search_page_level' | translate }}</div>
        <div class="starsContainer">
          <div><app-note-level [levelFilter]="levelFilter" (action)="handleLevelChange($event)" ></app-note-level></div>
          <div class="clearLevel blueColorHover" (click)="clearLevel()"><i class="pi pi-times"></i></div>
        </div>

        <div class="clearFilters blueColorHover" (click)="clearAllFilters()">{{ 'search_clear_filters' | translate }} <i class="pi pi-times"></i></div>

        <div *ngIf="mobileView" class="searchButton">
          <app-primary-button (action)="toggleFilters()" [label]="'search_mobile_button' | translate"></app-primary-button>
        </div>
      </div>

    </p-panel>
  </div>

  <div class="resultsContainer">
    <div class="searchInputContainer">
      <span class="ui-float-label searchInput">
        <input id="float-input" type="text" size="30" pInputText [(ngModel)]="searchQuery" (ngModelChange)="onInputTyping($event)">
        <label for="float-input">{{ 'main_page_enter_title' | translate }}</label>
      </span>
    </div>


    <div *ngIf="mobileView" (click)="toggleFilters()" class="blueColorHover openFilters" >
      <div style="display: flex;justify-content: space-between;width: 100%;">
        <div style="display: flex;"><i class="pi pi-sliders-h"></i> {{ 'search_filters' | translate }}</div>
        <app-primary-button (action)="toggleFilters()" [label]="'search_mobile_button' | translate"></app-primary-button></div>
      
    </div>

    <div class="sortContainer">
      <div style="margin-right: 15px;">{{ 'search_sort_by' | translate }}</div>

      <div class="labelsContainer">
        <div class="filterLabel blueColorHover" (click)="handleDateSort()">{{ 'search_sort_date' | translate }}</div>
        <div class="filterLabel blueColorHover" (click)="handlePriceSort()">{{ 'search_sort_price' | translate }}</div>
        <div class="filterLabel blueColorHover" (click)="handlePopularSort()">{{ 'search_sort_popular' | translate }}</div>
        <div class="filterLabel blueColorHover" (click)="handleTitleSort()">{{ 'search_sort_title' | translate }}</div>
      </div>

      <div class="sorting"  *ngIf="dateSort && dateSort === 'new'">{{ 'search_newest' | translate }}</div>
      <div  class="sorting" *ngIf="dateSort && dateSort === 'old'">{{ 'search_oldest' | translate }}</div>

      <div class="sorting"  *ngIf="priceSort && priceSort === 'low'">{{ 'search_cheapest' | translate }}</div>
      <div  class="sorting" *ngIf="priceSort && priceSort === 'high'">{{ 'search_most_expensive' | translate }}</div>

      <div  class="sorting" *ngIf="popularSort && popularSort === 'yes'">{{ 'search_popular' | translate }}</div>
      <div class="sorting"  *ngIf="popularSort && popularSort === 'no'">{{ 'search_unpopular' | translate }}</div>

      <div  class="sorting" *ngIf="titleSort && titleSort === 'A'">{{ 'search_az' | translate }}</div>
      <div class="sorting"  *ngIf="titleSort && titleSort === 'Z'">{{ 'search_za' | translate }}</div>
    </div>

    <p *ngIf="totalResults === 0">{{ 'search_no_reasults' | translate }}</p>
    <p *ngIf="totalResults === 1">{{ 'search_found' | translate }} {{totalResults}} {{ 'search_1' | translate }}</p>
    <p *ngIf="totalResults === 2 || totalResults === 3 || totalResults === 4">{{ 'search_found' | translate }} {{totalResults}} {{ 'search_234' | translate }}</p>
    <p *ngIf="totalResults >= 5">{{ 'search_found' | translate }} {{totalResults}} {{ 'search_5' | translate }}</p>

    <app-track-list [trackList]="searchNotes" [isSearch]="true"></app-track-list>

    <div *ngIf="isLoading" class="p-col-12 loader"><p-progressSpinner></p-progressSpinner></div>
  </div>

</div>


<div
  class="search-results"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  (scrolled)="onScroll()"
></div>
